import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TextsContext = createContext({ texts: null, loading: true });

export function TextsProvider({ children }) {
  const [texts, setTexts] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/texts`)
      .then(({ data }) => setTexts(data))
      .catch(() => setTexts(null))
      .finally(() => setLoading(false));
  }, []);

  return (
    <TextsContext.Provider value={{ texts, loading }}>
      {children}
    </TextsContext.Provider>
  );
}

export function useTexts() {
  return useContext(TextsContext);
}
